/** 서비스 전역 브랜드 표기 */
export const brandConfig = {
  name: "PropLake",
  title: "PropLake - 데이터로 읽는 부동산 시장",
  copyright: "© 2026 PropLake. All rights reserved.",
};
